import styled from 'styled-components'
import { Button, getPaletteColor } from 'pcln-design-system'

const StyledMenuButtonRemaining = styled(Button)`
  position: relative;
  align-items: center;
  height: 56px;
  &:focus-visible {
    outline: solid 3px ${getPaletteColor('primary.base')};
  }
`
// split the styles and added &&& to increase css rule specificity because of a bug in DS 4.16.2
// scrolling scroll down then up on hotels page breaks traveller selection
const StyledMenuButton = styled(StyledMenuButtonRemaining)`
  &&& {
    display: flex;
    padding: 0px;
  }
`

export default StyledMenuButton
